import React from "react";
import { cn } from "../../../common/u1/cn";
import { MEASURE } from "./editLayout";

/* The frame every section sits in. */

export { MEASURE };

export const EditSectionLayout = ({
  header,
  footer,
  children,
  className = "",
}) => (
  <div
    data-testid="edit-section-layout"
    className={cn(
      "grid min-h-0 w-full grid-rows-[minmax(0,1fr)_auto]",
      className
    )}
  >
    <div className="min-h-0 w-full overflow-y-auto py-6 sm:py-9">
      <div className={MEASURE}>
        {header}
        <div className={header ? "mt-7" : ""}>{children}</div>
      </div>
    </div>

    {footer}
  </div>
);

export default EditSectionLayout;
